/** Ren slug-hjälp för sålda fordon — används både i klient och server. */
export function slugifySv(input: string): string {
  return (input || "")
    .toLowerCase()
    .replace(/å|ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/é/g, "e")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 70);
}

/** Stabil, läsbar URL: titel + kort id-suffix så dubbletter aldrig krockar. */
export function soldSlug(title: string | null, id: string): string {
  const base = slugifySv(title ?? "fordon") || "fordon";
  const suffix = id.replace(/[^a-z0-9]/gi, "").slice(-6).toLowerCase();
  return `${base}-${suffix}`;
}
